{
  "auth": {
    "agree": "Nakubali",
    "createAccount": "Fungua akaunti",
    "createNewAccount": "Fungua Akaunti Mpya",
    "email": "Barua pepe",
    "login": "Ingia",
    "password": "Nywila",
    "recover_password": "Rudisha nywila",
    "sign_up": "Jisajili",
    "keep_logged_in": "Nikumbuke",
    "termsOfUse": "Masharti ya Matumizi.",
    "reset_password": "Weka nywila upya"
  },
  "404": {
    "title": "Ukurasa huu umeenda kuvua samaki.",
    "text": "Ikiwa unahisi kuwa si sahihi, tafadhali tutumie ujumbe kwa ",
    "back_button": "Rudi kwenye dashibodi"
  },
  "typography": {
    "primary": "Mitindo ya maandishi ya msingi",
    "secondary": "Mitindo ya maandishi ya ziada"
  },
  "dashboard": {
    "versions": "Matoleo",
    "setupRemoteConnections": "Sanidi Muunganisho wa Mbali",
    "currentVisitors": "Wageni wa Sasa",
    "navigationLayout": "mpangilio wa urambazaji",
    "topBarButton": "Upau wa Juu",
    "sideBarButton": "Upau wa Pembeni"
  },
  "language": {
    "brazilian_portuguese": "Kireno cha Brazil",
    "english": "Kiingereza",
    "spanish": "Kihispania",
    "simplified_chinese": "Kichina Rahisi",
    "persian": "Kiajemi",
    "swahili": "Kiswahili"
  },
  "menu": {
    "auth": "Uthibitishaji",
    "buttons": "Vitufe",
    "timelines": "Ratiba",
    "dashboard": "Dashibodi",
    "devices": "Vifaa",
    "device-list": "Orodha ya Vifaa",
    "add-device": "Ongeza Kifaa",
    "device-groups": "Vikundi vya Vifaa",
    "device-logs": "Kumbukumbu za Vifaa",
    "automation": "Uendeshaji Otomatiki",
    "scenes": "Mandhari",
    "automations": "Uendeshaji Otomatiki",
    "schedules": "Ratiba",
    "users": "Watumiaji",
    "user-list": "Orodha ya Watumiaji",
    "user-roles": "Majukumu",
    "user-permissions": "Ruhusa",
    "developer": "Mtengenezaji",
    "apps-list": "Programu",
    "api-keys": "Funguo za API",
    "webhooks": "Webhooks",
    "sdk": "SDK",
    "api-logs": "Kumbukumbu za API",
    "messaging": "Huduma ya Ujumbe",
    "cloud": "Wingu",
    "cloud-storage": "Hifadhi ya Wingu",
    "cloud-functions": "Kazi za Wingu",
    "data-analysis": "Uchambuzi wa Data",
    "documentation": "Nyaraka",
    "api-docs": "Nyaraka za API",
    "integration-guides": "Mwongozo wa Ushirikiano",
    "tutorials": "Mafunzo",
    "billing": "Malipo",
    "login": "Ingia",
    "preferences": "Mapendeleo",
    "services": "Usajili wa Huduma",
    "settings": "Mipangilio",
    "account": "Akaunti",
    "security": "Usalama",
    "notifications": "Arifa",
    "pricing-plans": "Mipango ya bei",
    "payment-methods": "Njia za malipo",
    "signup": "Jisajili",
    "recover-password": "Rudisha nywila",
    "recover-password-email": "Barua pepe ya kurudisha nywila",
    "404": "404",
    "faq": "Maswali Yanayoulizwa Mara kwa Mara",
    "projects": "Miradi",
    "project": "Mradi",
    "presence": "Huduma ya Uwepo",
    "streaming": "Huduma ya Kutiririsha",
    "video-call": "Simu ya Video",
    "voice-call": "Simu ya Sauti",
    "push-notifications": "Arifa za Kusukuma",
    "iot-core": "IoT Core",
    "iot-service": "Huduma ya IoT",
    "nx-messaging": "NX Ujumbe",
    "nx-presence": "NX Uwepo",
    "nx-streaming": "NX Kutiririsha",
    "nx-call": "NX Simu",
    "nx-push": "NX Arifa",
    "nx-iot-core": "NX IoT Core"
  },
  "messages": {
    "all": "Tazama ujumbe wote",
    "new": "Ujumbe mpya kutoka kwa {name}",
    "mark_as_read": "Weka kama Imesomwa"
  },
  "navbar": {
    "messageUs": "Maswali ya utengenezaji wa tovuti:",
    "repository": "Hifadhi ya GitHub"
  },
  "notifications": {
    "all": "Tazama arifa zote",
    "less": "Tazama arifa chache",
    "mark_as_read": "Weka kama imesomwa",
    "sentMessage": "amekutumia ujumbe",
    "uploadedZip": "amepakia faili mpya ya Zip yenye {type}",
    "startedTopic": "ameanza mada mpya"
  },
  "user": {
    "language": "Badilisha lugha",
    "logout": "Toka",
    "profile": "Wasifu",
    "appearance": "Muonekano",
    "settings": "Mipangilio",
    "billing": "Malipo",
    "faq": "Maswali Yanayoulizwa Mara kwa Mara",
    "helpAndSupport": "Usaidizi na msaada",
    "projects": "Miradi",
    "account": "Akaunti",
    "explore": "Chunguza",
    "myProfile": "Wasifu Wangu",
    "security": "Usalama",
    "changePassword": "Badilisha Nywila",
    "apiKeys": "Funguo za API",
    "myDevices": "Vifaa Vyangu",
    "myAutomations": "Uendeshaji Otomatiki Wangu",
    "services": "Huduma",
    "documentation": "Nyaraka",
    "support": "Msaada",
    "management": "Usimamizi",
    "help": "Usaidizi"
  },
  "users": {
    "title": "Watumiaji wa Wateja",
    "subtitle": "Dhibiti ufikiaji na ruhusa za wateja",
    "addUser": "Ongeza Mtumiaji",
    "moreFilters": "Vichujio Zaidi",
    "searchPlaceholder": "Tafuta watumiaji...",
    "filterStatus": "Chuja kulingana na hali",
    "noUsersFound": "Hakuna watumiaji waliopatikana",
    "noUsersHint": "Jaribu kuonua au angalia muunganisho wako wa API",
    "addNewUser": "Ongeza Mtumiaji Mpya wa Mteja",
    "editUser": "Hariri Mtumiaji",
    "firstName": "Jina la Kwanza",
    "lastName": "Jina la Mwisho",
    "username": "Jina la Mtumiaji",
    "email": "Barua pepe",
    "password": "Nywila",
    "confirmPassword": "Thibitisha Nywila",
    "phoneNumber": "Nambari ya Simu",
    "bio": "Wasifu",
    "profilePicture": "Picha ya Wasifu",
    "usernameSecurityNote": "Jina la mtumiaji haliwezi kubadilishwa kwa sababu za usalama",
    "cancel": "Ghairi",
    "createUser": "Tengeneza Mtumiaji",
    "updateUser": "Sasisha Mtumiaji",
    "deleteUser": "Futa Mtumiaji",
    "userDetails": "Maelezo ya Mtumiaji",
    "close": "Funga",
    "editUserFromView": "Hariri Mtumiaji",
    "noUserDetails": "Hakuna maelezo ya mtumiaji yanapatikana",
    "personalInformation": "Maelezo ya Kibinafsi",
    "contact": "Mawasiliano",
    "accountDetails": "Maelezo ya Akaunti",
    "userId": "Kitambulisho cha Mtumiaji",
    "createdDate": "Tarehe ya Uundaji",
    "clientName": "Jina la Mteja",
    "phoneVerified": "Simu Imethibitishwa",
    "verified": "Imethibitishwa",
    "notVerified": "Hajathibitishwa",
    "active": "Amilisha",
    "inactive": "Haiamilishi"
  },
  "apps": {
    "title": "Programu",
    "subtitle": "Dhibiti programu zako za NexaConn na sifa za API",
    "newApplication": "Programu Mpya",
    "totalApps": "Jumla ya Programu",
    "active": "Amilisha",
    "appsWithKeys": "Ziwa na Funguo za API",
    "inDevelopment": "Katika Maendeleo",
    "loadingApplications": "Inapakia programu…",
    "noApplicationsYet": "Hakuna Programu Bado",
    "noApplicationsDescription": "Tengeneza programu yako ya kwanza ili kupata sifa za API na kuunganisha na jukwaa la NexaConn.",
    "createApplication": "Tengeneza Programu",
    "searchPlaceholder": "Tafuta programu…",
    "details": "Maelezo",
    "editApp": "Hariri Programu",
    "close": "Funga",
    "newApplicationModal": "Programu Mpya",
    "connectToPlatform": "Unganisha na jukwaa la NexaConn",
    "applicationName": "Jina la Programu",
    "applicationNamePlaceholder": "k.m. Nexa Transport",
    "description": "Maelezo",
    "descriptionPlaceholder": "Eleza madhumuni ya programu hii",
    "cancel": "Ghairi",
    "createApplicationButton": "Tengeneza Programu",
    "applicationInfo": "Maelezo ya Programu",
    "appId": "Kitambulisho cha Programu",
    "type": "Aina",
    "created": "Imetengenezwa",
    "updated": "Imesasishwa",
    "client": "Mteja",
    "username": "Jina la Mtumiaji",
    "email": "Barua pepe",
    "apiKey": "Funguo la API",
    "secretKey": "Funguo ya Siri",
    "keyInfo": "Maelezo ya Funguo",
    "valid": "Halali",
    "expired": "Imekwishwa",
    "keyExpiry": "Muda wa Kukwishwa wa Funguo",
    "keyCreated": "Funguo Imetengenezwa",
    "noApiKey": "Hakuna funguo ya API inapatikana",
    "noSecretKey": "Hakuna funguo ya siri inapatikana"
  },
  "treeView": {
    "basic": "Msingi",
    "icons": "Ikoni",
    "selectable": "Inayoweza Kuchaguliwa",
    "editable": "Inayoweza Kuhaririwa",
    "advanced": "Mahiri"
  },
  "chat": {
    "title": "Mazungumzo",
    "sendButton": "Tuma"
  },
  "spacingPlayground": {
    "value": "Thamani",
    "margin": "Ukingo",
    "padding": "Pedi"
  },
  "spacing": {
    "title": "Nafasi"
  },
  "cards": {
    "cards": "Kadi",
    "fixed": "Imara",
    "floating": "Inayoelea",
    "contentText": "Mistari ya kipekee ya punda-milia huwafanya kuwa wanyama wanaofahamika zaidi kwa watu.",
    "contentTextLong": "Mistari ya kipekee ya punda-milia huwafanya kuwa wanyama wanaofahamika zaidi kwa watu. Wanapatikana katika makazi mbalimbali, kama vile nyika, savana, misitu, vichaka vya miiba, milima, na vilima vya pwani. Sababu mbalimbali za kibinadamu zimekuwa na athari kubwa kwa idadi ya punda-milia, hasa uwindaji wa ngozi na uharibifu wa makazi. Punda-milia wa Grévy na punda-milia wa mlima wako hatarini kutoweka. Wakati punda-milia wa tambarare ni wengi zaidi, aina moja ndogo, quagga.",
    "rowHeight": "Urefu wa mstari",
    "title": {
      "default": "Chaguo-msingi",
      "withControls": "Na vidhibiti",
      "customHeader": "Kichwa maalum",
      "withoutHeader": "Bila kichwa",
      "withImage": "Na Picha",
      "withTitleOnImage": "Na kichwa juu ya picha",
      "withCustomTitleOnImage": "Na kichwa maalum juu ya picha",
      "withStripe": "Na mstari",
      "withBackground": "Na mandharinyuma"
    },
    "button": {
      "main": "Kuu",
      "cancel": "Ghairi",
      "showMore": "Onyesha Zaidi",
      "readMore": "Onyesha Zaidi"
    },
    "link": {
      "edit": "Hariri",
      "setAsDefault": "Weka kama chaguo-msingi",
      "delete": "Futa",
      "traveling": "Kusafiri",
      "france": "Ufaransa",
      "review": "Hakiki",
      "feedback": "Toa maoni",
      "readFull": "Soma makala kamili",
      "secondaryAction": "Kitendo cha pili",
      "action1": "Kitendo 1",
      "action2": "Kitendo 2"
    }
  },
  "colors": {
    "themeColors": "Rangi za Mandhari",
    "extraColors": "Rangi za Ziada",
    "gradients": {
      "basic": {
        "title": "Gradients za Kitufe"
      },
      "hovered": {
        "title": "Gradients za Kitufe Kilichozungushiwa",
        "text": "Kuangaza 15% kumetumika kwenye mtindo wa asili (gradient au rangi tambarare) kwa hali ya kuzungusha."
      },
      "pressed": {
        "title": "Gradients za Kitufe Kilichobonyezwa",
        "text": "Kufifisha 15% kumetumika kwenye mtindo wa asili (gradient au rangi tambarare) kwa hali ya kubonyeza."
      }
    }
  },
  "tabs": {
    "alignment": "Mpangilio wa tabs",
    "overflow": "Tabs zinazofurika",
    "hidden": "Tabs zenye slider iliyofichwa",
    "grow": "Tabs zinazokua"
  },
  "helpAndSupport": "Usaidizi na msaada",
  "aboutVuesticAdmin": "Kuhusu Vuestic Admin",
  "supportAndConsulting": "Msaada na Ushauri",
  "search": {
    "placeholder": "Tafuta..."
  },
  "buttonSelect": {
    "dark": "Giza",
    "light": "Mwanga"
  },
  "vuestic": {
    "search": "Tafuta",
    "noOptions": "Vipengee havikupatikana",
    "ok": "Sawa",
    "cancel": "Ghairi",
    "uploadFile": "Pakia faili",
    "undo": "Tengua",
    "dropzone": "Dondosha faili hapa ili kupakia",
    "fileDeleted": "Faili imefutwa",
    "closeAlert": "funga arifa",
    "backToTop": "rudi juu",
    "toggleDropdown": "geuza dropdown",
    "carousel": "carousel",
    "goPreviousSlide": "nenda slaidi iliyopita",
    "goNextSlide": "nenda slaidi inayofuata",
    "goSlide": "nenda slaidi {index}",
    "slideOf": "slaidi {index} kati ya {length}",
    "close": "funga",
    "openColorPicker": "fungua kichaguzi cha rangi",
    "colorSelection": "uchaguzi wa rangi",
    "colorName": "rangi {color}",
    "decreaseCounter": "punguza hesabu",
    "increaseCounter": "ongeza hesabu",
    "selectAllRows": "chagua safu zote",
    "sortColumnBy": "panga safu kwa {name}",
    "selectRowByIndex": "chagua safu {index}",
    "resetDate": "weka upya tarehe",
    "nextPeriod": "kipindi kinachofuata",
    "switchView": "badilisha mwonekano",
    "previousPeriod": "kipindi kilichopita",
    "removeFile": "ondoa faili",
    "reset": "weka upya",
    "pagination": "ukatizaji wa kurasa",
    "goToTheFirstPage": "nenda kwenye ukurasa wa kwanza",
    "goToPreviousPage": "nenda kwenye ukurasa uliopita",
    "goToSpecificPage": "nenda kwenye ukurasa wa {page}",
    "goToSpecificPageInput": "ingiza namba ya ukurasa wa kwenda",
    "goNextPage": "nenda ukurasa unaofuata",
    "goLastPage": "nenda ukurasa wa mwisho",
    "currentRating": "tathmini ya sasa {value} kati ya {max}",
    "voteRating": "tathmini ya kupiga kura {value} kati ya {max}",
    "optionsFilter": "chujio la chaguo",
    "splitPanels": "gawa paneli",
    "movePaginationLeft": "sogeza ukatizaji wa kurasa kushoto",
    "movePaginationRight": "sogeza ukatizaji wa kurasa kulia",
    "resetTime": "weka upya muda",
    "closeToast": "funga toast",
    "selectedOption": "Chaguo lililochaguliwa",
    "noSelectedOption": "Chaguo halijachaguliwa",
    "breadcrumbs": "breadcrumbs",
    "counterValue": "thamani ya hesabu",
    "selectedDate": "tarehe iliyochaguliwa",
    "selectedTime": "muda uliochaguliwa",
    "progressState": "hali ya maendeleo",
    "color": "rangi",
    "next": "Inayofuata",
    "back": "Iliyopita",
    "finish": "Maliza",
    "step": "hatua",
    "progress": "maendeleo",
    "loading": "Inapakia",
    "sliderValue": "Thamani ya slider ya sasa ni {value}",
    "switch": "Swichi",
    "inputField": "Sehemu ya kuingiza",
    "fileTypeIncorrect": "Aina ya faili si sahihi",
    "select": "Chagua chaguo"
  }
}
